module.exports = __webpack_public_path__ + "img/offline.aa15b21e.svg";